const initialState = {
  panels: [],
  isEditMode: false,
  panelLayout: 'default',
  appConfig: []
};

export default initialState;
